import { Routes } from '@angular/router';
import { CustomMenuService } from '@app/global services';
import { IloginConfig } from 'viggo-sistemas-core-web';

export const routesUnloggedUser: Routes = [
  {
    path: 'auth',
    loadChildren: () =>
      import('@app/modules/wrapperModules/auth-wrapper.module').then(
        a => a.AuthWrappereModule
      ),
    data: {
      loginConfig: {
        softwareHouseAppName: 'WoundCareSys',
        softwareHouselogoTopBar: 'assets/images/WoundCareSys-icone.png',
        softwareHouseLanding: 'landing',
        softwareHouseSlogan: ' ',
        softwareHouseLogoURL: 'assets/images/logo-white.png',
        defaultBg: 'assets/images/login-bg.png',
        softwareHouseLimitTokens: true,
        menuService: CustomMenuService // SE FOR USAR O BREADCRUMB COM CAMINHO DOS MENUS PASSE ESSA CLASSE DE SERVIÇO QUE É INSTANCIADA NO CORE
      } as IloginConfig
    }
  },
  {
    path: 'reset/:token_id/:domain_name',
    redirectTo: '/auth/reset/:token_id/:domain_name'
  },
  {
    path: 'activate/:token/:domain_id/:user_id',
    redirectTo: 'landing/activate/:token/:domain_id/:user_id'
  }
];
